export {default} from "../cartforms/ColorSwatchesCartForm";



// WEBPACK FOOTER //
// ./src/components/async/ColorSwatchesCartForm.js